(function() {

    var globals = require("./globals.js")
    var graph = require("./graph.js")
    var utils = require("./utils.js")
//    var timeline =require("../timeline.js")
//    var timeline = require("../timeline.js")
    
    module.exports = {
	findAttendees: findAttendees,
	filterEvents: filterEvents,
	filterPeople: filterPeople,
	find: find,
	findConnections: findConnections,
	analyseAll: analyseAll,
    }

    function find(name, type) {
	//	console.log(globals._data)
        field = type === 'events' ? 'eventName' : 'name';
        object = type === 'events' ? 'ellipse#' : 'circle#';
        result = globals._data.nodesData.filter(function(d) { return d[field] === name; });
        console.log(result)
        if(result.length > 0) {
            id = result[0].id;
            console.log(id)
            d3.select(object+id)
                .attr("class", "selected");
            utils.scrollTo(id);
            return false
        } else {
//            alert(globals.copy.noResults)
			if(type === 'people') {
                person = globals._data.master.people.filter(function(d) { return d[field] === name; });
                var pID = person[0].id;
				links = globals._data.master.links.filter(function(d) {
                    if(typeof d.source === 'string') {
                        return d.source === pID;
                    } else {
                        return d.source.id === pID;
                    };
				});
                console.log(pID)
                console.log(links)
                globals._data.nodesData.push(person[0])
                globals._data.linksData = globals._data.linksData.concat(links);
				return pID
            }
        }
    }

    
    function findAttendees(event, data) {
//	console.log(data.master.links)
	newLinks = data.master.links.filter( function(l) {
	    if(typeof l.target == 'string') {
		return l.target == event;
	    } else {
		return l.target.id == event;
	    }
	})
	newLinks = newLinks.filter(function(d) { return utils.checkExists(d.id, globals._data.linksData, 'id') == false;});
//	console.log(newLinks)
	newPeople = [];
//	linksData = linksData.concat(newLinks);
	currentPeople = data.nodesData.filter( function(d) { return d.type == 'person'; });
	for(dd in newLinks) {
	    if(utils.checkExists(newLinks[dd].source, currentPeople, 'id') == false) {
		person = data.master.people.filter( function(p) {
		    if(typeof newLinks[dd].source == 'string') {
			return p.id == newLinks[dd].source; 
		    } else {
			return p.id == newLinks[dd].source.id;
		    }
		})[0]
		
		person.type = 'person';
		newPeople.push(person);
		currentPeople.push(person);
	    }
	};
//	console.log(event)
//	newLinks.forEach(function(el) {
//	    el.source = newPeople.filter(function(d) { return d.id == el.source; })[0]
//	    el.target = globals._data.nodesData.filter(function(d) { return d.id == el.target; })[0]
//	});
//	graph.fixEvents(nodesData)
	
	return {newLinks: newLinks, newPeople:newPeople}
	
//	updateNetwork()
    }
    
    function filterEvents(cats) {
        /*
        nodesData.filter(function(d) { return d.type == 'event'; }).forEach(function(e) {
            e.fy = e.y;
        })*/
        people = globals._data.nodesData.filter(function(d) { return d.type == 'person'; })

//	var startDateFilter = $("#startDateFilter").find(":selected").text();
//	var endDateFilter = $("#endDateFilter").find(":selected").text();

		var startDateFilter = 1900;
        var endDateFilter = 1970;

        newEvents = globals._data.master.events.filter(function(d) {
            type = d.eventType
            add = false;
            if(d.startDate !='' && d.endDate !='') {
                start = utils.formatDate(d.startDate);
                end = utils.formatDate(d.endDate);
                if((start <= startDateFilter && end >= endDateFilter) || (end >= startDateFilter && end <= endDateFilter) || (start >= startDateFilter && start <= endDateFilter)) {
                    add = utils.checkExists(type, cats, 'title')
                }
            } else if(d.date != '') {
                if(utils.formatDate(d.date) >= startDateFilter && utils.formatDate(d.date) <= endDateFilter) {
                    add = utils.checkExists(type, cats, 'title')
                }
            }
            if(add == true) {
                return d;
            }
        });

        mainPpl = []

        $(".name-label.active").each(function(){
            mainPpl.push($(this).attr("data-id"));
        });

        if(mainPpl.length < 3) {
            newEvents = newEvents.filter(function(d) { return utils.checkExists(d.datasets[0], mainPpl, 'none') == true;})
        }

  /*      var location = $("#locationFilter").val();

        if(location != '') {
            newEvents = newEvents.filter(function(d) { return d.location == location; });
        }
*/
 /*       venue = $("#venueFilter").val();
        if(venue != '') {
            newEvents = newEvents.filter(function(d) { return d.venue == venue});
        }
*/
        globals._data.nodesData = people.concat(newEvents);

        if(globals._data.linksData.length > 0) {
            el = graph.removeUnlinkedPeople(globals._data.nodesData, globals._data.linksData);
            globals._data.linksData = linksData = el.links;
            globals._data.nodesData = el.nodes;
        }


	    
	    
	
//	console.log(nodesData)
//	console.log(linksData)
//	updateEvents();
    }
    
    function filterPeople() {
	female = $("#femaleFilter").checked;
	male = $("#maleFilter").checked;
	rel = $("#relFilter").val();
	profession = $("#professionFilter").val();
	party = $("#partyFilter").val();
	residence = $("#birthFilter").val();

	events = globals._data.nodesData.filter(function(d) { return d.type == 'event'; })
	people = globals._data.nodesData.filter(function(d) { return d.type == 'person'; })
	console.log(male)
	if(!female) {
	    newPeople = people.filter(function(d) { return d.gender == 'Male'; });
	} else if (!male) {
	    newPeople = people.filter(function(d) { return d.gender == 'Female'; });
	    
	}
	console.log(newPeople)

	if(rel!='') {
	    newPeople = newPeople.filter(function(d) { return d.relProtagonist == rel; })
	}

	console.log(newPeople)

	if(profession !='') {
	     newPeople = newPeople.filter(function(d) { return d.proffesion == profession; })
	}

	console.log(newPeople)
	console.log(party)
	if(party != '') {
	     newPeople = newPeople.filter(function(d) { return d.party == party; })
	}

	console.log(newPeople)
	console.log(residence)
	if(residence !='') {
	     newPeople = newPeople.filter(function(d) { return d.residence == residence; })
	}
	console.log(newPeople)
	globals._data.linksData = globals._data.linksData.filter(function(d) { return utils.checkExists(d.source.id, newPeople, 'id') == true; })
	globals._data.nodesData = events.concat(newPeople);
    }

    var finalResults = [];
    
    function findConnections(pA, pB) {
	console.log(pA)
	console.log(pB)
	pA = globals._data.master.people.filter(function(d) { return d.name == pA; })[0];
	pB = globals._data.master.people.filter(function(d) { return d.name == pB; })[0];
	gen1Events = globals._data.master.links.filter(function(d) { return d.source == pA.id;});
	
	finalResults = [];
	step(gen1Events, pB);
	
	console.log(finalResults)
	
/*	if(results.length == 0) {
	} else {
	    event = globals._data.master.events.filter(function(d) { return d.id == results[0].target;})[0];
	    link = globals._data.master.links.filter(function(d) { return d.target == results[0].target && d.source == pA.id; })[0]
	    globals._data.nodesData = [pA, pB, event]
	    globals._data.linksData = [results[0], link]
	    console.log(globals._data.nodesData)
	    console.log(globals._data.linksData)
	}*/
    }

    function immediateConnections(eventLinks) {
    	var genPpl = [];
	eventLinks.forEach(function(el) {
	    ppl = globals._data.master.links.filter(function(d) { return el.target == d.target; })
	    genPpl.push({pA: el.source, event: el.target, people: ppl})
	})
	return genPpl;
    }
    
    function findTarget(links, person) {
	result = []
	console.log(links)
	for(p in links) {
	    target = links[p].people.filter(function(d) { return d.source == person.id; });
	    if(target.length > 0 ) {
		result = result.concat(target);
	    }
	}
//	console.log(result)
	return result;
    }
    
    var pplLinks = [];
    var eventsDone = [];
    
    function step(eventLinks, pB) {
	//	pplLinks = [];
	gen1 = immediateConnections(eventLinks);
	pplLinks.push(gen1)
	eventsDone = eventsDone.concat((gen1))
//	console.log(eventsDone)
	results = [];
	i = pplLinks.length;
	while(i>0) {
	    results = results.concat(findTarget(pplLinks[i-1], pB));
	    i = i -1;
	}
	console.log(results.length)
	if(results.length > 0) {
//	    console.log(results)
	    finalResults.push(results);
	    
	} else {
	    stepEvents = [];
	    pplLinks[pplLinks.length -1].forEach(function(el) {
		el.people.forEach(function(p) {
		    newEvents = globals._data.master.links.filter(function(d) { return d.source == p.source; });
		    newEvents.forEach(function(d) {
			if(utils.checkExists(d.target, stepEvents, 'target')==false && utils.checkExists(d.target, eventsDone, 'event') == false) {
			    stepEvents.push(d)
			}
		    });
				  
		});
	    });
	   // eventsDone = eventsDone.concat(stepEvents);
	    
//	    console.log(stepEvents)
	    step(stepEvents, pB);				
	}
    }

    function analyseAll() {
	result = {
	    count: {
		events: globals._data.nodesData.filter(function(d) { return d.type == 'event';}).length,
		people: globals._data.nodesData.filter(function(d) { return d.type == 'person'; }).length,
		links: globals._data.linksData.length,
	    },
	    professions:[],
	    genders: [],
	    relations: [],
	    parties: [],
	    residences: [],
	    allPeople: [],
	    venues: [],
	    locations: [],
	    categories: [],
	    allEvents: [],	
	}

	globals._data.nodesData.forEach(function(el) {
	    if(el.type == 'event') {
		utils.checkList(el.venue, result.venues)
		utils.checkList(el.location, result.locations)
		utils.checkList(el.eventType, result.categories)
	    } else {
		utils.checkList(el.residence, result.residences)
		utils.checkList(el.party, result.parties)
		utils.checkList(el.relProtagonist, result.relations)
		utils.checkList(el.proffesion, result.professions)
		utils.checkList(el.gender, result.genders)
	    }
	});

	globals._data.linksData.forEach(function(el) {
	    utils.checkList(el.source.id, result.allPeople)
	    utils.checkList(el.target.id, result.allEvents)
	});
	result.allPeople = utils.sortDescending(result.allPeople, 'value')
	result.allEvents = utils.sortDescending(result.allEvents, 'value')

	result.allPeople = result.allPeople.slice(0,10)
	result.allEvents = result.allEvents.slice(0,10)

	result.allPeople.forEach(function(d) {
	    d.name = globals._data.master.people.filter(function(p) { return p.id == d.title; })[0].name
	})

	result.allEvents.forEach(function(d) {
	    d.name = globals._data.master.events.filter(function(p) { return p.id == d.title; })[0].eventName
	})

	return result;
			  
    }
    
})();
